import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.config';
import { FUND_DECK_PHONE_ERROR, isValidFundDeckPhone } from './fundDeckPhone';

export const FUND_DECK_TOKEN_STORAGE_KEY = 'kyroFundDeckToken';
const SESSION_KEY = FUND_DECK_TOKEN_STORAGE_KEY;

const callableOpts = { timeout: 90_000 };

export async function submitFundDeckRequest(payload: {
  name: string;
  email: string;
  phone: string;
  organisation?: string | null;
}): Promise<string> {
  const phone = payload.phone.trim();
  if (!isValidFundDeckPhone(phone)) {
    throw new Error(FUND_DECK_PHONE_ERROR);
  }
  const submit = httpsCallable(functions, 'submitDeckRequestAndSession', callableOpts);
  const res = await submit({
    name: payload.name.trim(),
    email: payload.email.trim(),
    phone,
    organisation: payload.organisation?.trim() || null,
  });
  const data = res.data as { token?: string };
  if (!data?.token) {
    throw new Error('Invalid response from server.');
  }
  try {
    sessionStorage.setItem(SESSION_KEY, data.token);
  } catch {
    /* private mode */
  }
  return data.token;
}

export function getStoredFundDeckToken(): string | null {
  try {
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

export function clearStoredFundDeckToken(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Returns true if the stored session token is still valid on the server. Clears storage if not. */
export async function validateStoredDeckSession(): Promise<boolean> {
  const token = getStoredFundDeckToken();
  if (!token) return false;
  try {
    const fn = httpsCallable(functions, 'checkDeckSession', callableOpts);
    const res = await fn({ token });
    const valid = Boolean((res.data as { valid?: boolean })?.valid);
    if (!valid) clearStoredFundDeckToken();
    return valid;
  } catch {
    return false;
  }
}
